<!-- @format -->
<ng-container *ngIf="action === 'select-to-plan'">
  @if (inputType === "radio-button") {
    <sis-simple-radio-button
      [selected]="selected"
      [id]="actionInputId"
      [name]="actionInputName"
      [label]="module.name | localizedString"
      [visuallyHiddenInfo]="module.name | localizedString"
      (selectedChange)="toggleSelected()" />
  } @else {
    <sis-checkbox
      [checked]="selected"
      [id]="actionInputId"
      (checkedChange)="toggleSelected()"
      [name]="actionInputName"
      [visuallyHiddenInfo]="module.name | localizedString"
      [label]="module.name | localizedString">
    </sis-checkbox>
  }
</ng-container>
